var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 18.4641C27.2917 16.9245 27.2917 13.0755 24.625 11.5359L14.125 5.47372C11.4583 3.93412 8.125 5.85863 8.125 8.93783L8.125 21.0622C8.125 24.1414 11.4583 26.0659 14.125 24.5263L24.625 18.4641Z",
    fill: "#36ACD6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.75,
    height: 23.75,
    rx: 1.875,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 31.25 26.875)",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/Three.9c5f30539744fbecfd63ed95b4bd3ed7.svg";
export { ForwardRef as ReactComponent };